<template>
    <div class="page" style="background-color: #ffffff;margin-bottom: 40px;">
      <div style="width: 100%;padding-bottom: 10px;margin-top: 5px;text-align: center" class="mypage">
        <el-radio-group v-model="tabPosition" @change="perfClick" size="mini">
          <el-radio-button label="1">今天</el-radio-button>
          <el-radio-button label="2">本月</el-radio-button>
          <el-radio-button label="3">上月</el-radio-button>
          <el-button v-popover:popover size="mini">自定义</el-button>
        </el-radio-group>
      </div>
      <el-popover
        placement="bottom"
        width="400"
        ref="popover"
        trigger="click">
        <el-form label-position="left" inline class="myform" style="margin-left: 50px">
          <el-row>
            <el-col :span="24">
              <el-form-item label="日期">
                <el-date-picker style="width: 130px" v-model="bfrommonth" type="month" placeholder="选择月" value-format="yyyy-MM" @change="monthchange">
                </el-date-picker>
                <el-date-picker style="width: 130px" v-model="btomonth" type="month" placeholder="选择月" value-format="yyyy-MM" @change="monthchange">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-popover>
      <el-table :data="custInfos" border style="width: 100%" height="290px" size="mini">
        <el-table-column prop="lable" label="名称"></el-table-column>
        <el-table-column prop="nowmonth" :label="columnname1" >
          <template slot-scope="scope">
            {{ parseInt(scope.row.nowmonth)}}
            <span v-if="scope.row.nownumber>0">({{scope.row.nownumber}})</span>
          </template>
        </el-table-column>
        <el-table-column prop="befogermonth" :label="columnname2" >
          <template slot-scope="scope">
            {{ parseInt(scope.row.befogermonth)}}
            <span v-if="scope.row.befogernumber>0">({{scope.row.befogernumber}})</span>
          </template>
        </el-table-column>
        <el-table-column prop="lv" label="增长率" >
          <template slot-scope="scope">
            {{Math.round(scope.row.lv * 100)}}%
          </template>
        </el-table-column>
      </el-table>
      <el-divider>提成数据</el-divider>
    <el-card class="box-card" shadow="never">
        <div slot="header" class="clearfix" style="text-align: center">
          <el-radio-group v-model="mytabPosition" @change="myData" size="mini">
            <el-radio-button label="1">今天</el-radio-button>
            <el-radio-button label="2">本月</el-radio-button>
            <el-radio-button label="3">上月</el-radio-button>
          </el-radio-group>
        </div>
        <div class="text item">
          <el-form label-position="left" inline>
            <el-row>
              <el-col :span="12">
                <el-form-item label="总提成">
                  <span>{{ $parseInt(stafftotalperf.totalcomm) }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="现金提成">
                  <span>{{ $parseInt(stafftotalperf.totalcashcomm)}}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="卡付提成">
                  <span>{{$parseInt(stafftotalperf.totalcardcomm)}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="其他提成">
                  <span>{{$parseInt(stafftotalperf.totalothercomm)}}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="人头提成">
                  <span>{{$parseInt(stafftotalperf.headamount)}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="兑换提成">
                  <span>{{$parseInt(stafftotalperf.exchangecomm)}}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="附带成长">
                  <span>{{$parseInt(stafftotalperf.growup)}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="上月老点">
                    <span>{{$parseInt(stafftotalperf.befldnumber)}}</span>
                  </el-form-item>
              </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                  <el-form-item label="本月老点">
                    <span>{{$parseInt(stafftotalperf.ldnumber)}}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <router-link to='/empperfdetal'>
                    <el-button type="text">查看明细</el-button>
                  </router-link>
                </el-col>
              </el-row>
          </el-form>
        </div>
    </el-card>
</div>
</template>
<script>
    export default {
        data() {
            return {
                mytabPosition:1,
                columnname1:"今天",
                columnname2:"昨天",
                tabPosition:1,
                bfrommonth:"",
                btomonth:"",
                custInfos:[],
                fromdate:this.$moment().format("YYYY-MM-DD"),
                todate:this.$moment().format("YYYY-MM-DD"),
                bfromdate:this.$moment().subtract(1, 'days').format('YYYY-MM-DD'),
                btodate:this.$moment().subtract(1, 'days').format('YYYY-MM-DD'),
                custfromdate:this.$moment().format("YYYY-MM-DD"),
                custtodate:this.$moment().format("YYYY-MM-DD"),
                stafftotalperf:{},
                storeid:localStorage.getItem("storeid"),
                staffid:localStorage.getItem("staffid")
            }
        },
        created: function () {
            this.getHairDataByStaffId();
            this.getStaffSalaryById(this.mytabPosition);
        },
        methods:{
            myData(e){
                if(e==1){
                    this.custfromdate=this.$moment().format("YYYY-MM-DD");
                    this.custtodate=this.$moment().format("YYYY-MM-DD");
                }
                else if(e==2){
                    this.custfromdate=this.$moment().startOf('month').format('YYYY-MM-DD');
                    this.custtodate=this.$moment().endOf('month').format('YYYY-MM-DD');
                }
                else if(e==3){
                    let days=this.$moment(this.$moment().format('YYYY-MM-')+'01').startOf('month').subtract(1, 'days').format('YYYY-MM');
                    this.custfromdate=days+"-01";
                    this.custtodate=days+"-"+this.$moment(this.custfromdate, "YYYY-MM-DD").daysInMonth();
                }
                this.getStaffSalaryById(this.mytabPosition);
            },
            perfClick(e){
                if(e=="1"){
                    this.fromdate=this.$moment().format("YYYY-MM-DD");
                    this.todate=this.$moment().format("YYYY-MM-DD");
                    this.bfromdate=this.$moment().subtract(1, 'days').format('YYYY-MM-DD');
                    this.btodate=this.$moment().subtract(1, 'days').format('YYYY-MM-DD');
                    this.columnname1="今天";
                    this.columnname2="昨天";
                }
                else if(e=="2"){
                    this.fromdate=this.$moment().startOf('month').format('YYYY-MM-DD');
                    this.todate=this.$moment().endOf('month').format('YYYY-MM-DD');
                    let days=this.$moment(this.$moment().format('YYYY-MM-')+'01').startOf('month').subtract(1, 'days').format('YYYY-MM');
                    this.bfromdate=days+"-01";
                    this.btodate=days+"-"+this.$moment(this.bfromdate, "YYYY-MM-DD").daysInMonth();
                    this.columnname1="本月";
                    this.columnname2="上月";
                }
                else if(e=="3"){
                    let days=this.$moment(this.$moment().format('YYYY-MM-')+'01').startOf('month').subtract(1, 'days').format('YYYY-MM');
                    this.fromdate=days+"-01";
                    this.todate=days+"-"+this.$moment(this.fromdate, "YYYY-MM-DD").daysInMonth();
                    this.columnname1=days.substring(5,7)+"月";

                    days=this.$moment(this.fromdate).startOf('month').subtract(1, 'days').format('YYYY-MM');
                    this.bfromdate=days+"-01";
                    this.btodate=days+"-"+this.$moment(this.bfromdate, "YYYY-MM-DD").daysInMonth();
                    this.columnname2=days.substring(5,7)+"月";
                }
                this.getHairDataByStaffId();
            },
            monthchange(e) {
                if (this.bfrommonth && this.btomonth) {
                    this.fromdate = this.bfrommonth + "-01";
                    this.todate = this.$moment(this.fromdate).endOf('month').format('YYYY-MM-DD');
                    this.bfromdate = this.btomonth + "-01";
                    this.btodate = this.$moment(this.bfromdate).endOf('month').format('YYYY-MM-DD');
                    this.columnname1=this.fromdate.substring(5,7)+"月";
                    this.columnname2=this.bfromdate.substring(5,7)+"月";
                    this.bfrommonth="";
                    this.btomonth="";
                    this.$refs["popover"].doClose();
                    this.getHairDataByStaffId();
                }
            },
            getHairDataByStaffId(){
                this.$post("staff/getBeautyDataByStaffId",{storeid:this.storeid,fromdate:this.fromdate,todate:this.todate,bfromdate:this.bfromdate,btodate:this.btodate,staffid:this.staffid}).then(res=>{
                    if(res.sucess){
                        this.custInfos=res.object;
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            },
            getStaffSalaryById(type){
                this.$post("calsalary/getStaffSalaryByIdNew",{storeid:this.storeid,fromdate:this.custfromdate,todate:this.custtodate,staffid:this.staffid,type:type}).then(res=>{
                    if(res.sucess){
                        if(res.object){
                            this.stafftotalperf = res.object;
                        }
                        else{
                            this.stafftotalperf = {};
                        }
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            }
        }
    }
</script>
<style style lang="scss" rel="stylesheet/scss">
    .page .el-form-item{
      margin-bottom:0px;
    }
    .page .el-card{
      border: 0px;
    }
    .page .el-radio-button__inner, .el-radio-group{
      display: block;
    }
  
    .page .el-tabs__content {
      height: calc(100% - 30px);
    }
  
    .page .el-tabs{
      height: calc(100% - 349px);
    }
  
    .page .el-tab-pane{
      height: calc(100%);
    }
  
    .page .el-table{
      font-size:10px;
    }
  
    .page .el-form-item__content{
      font-size:10px;
    }
  
    .page .el-form-item__label{
      font-size:10px;
    }
  
    .page .el-tabs__header{
      margin:0 0 2px;
    }
  
    .page .el-card__header{
      padding:2px 2px;
    }
  
    .mypage .el-tabs__header{
      margin:0 0 15px;
    }
  
    .myform .el-form-item{
      margin-right:0px;
    }
  
    .page .el-table td, .el-table th{
      padding:5px 0;
    }
  
  
    .el-table .blue {
      background: #dbf6cb;
    }
  
    .el-table .orange {
      background: #fcebcd;
    }
  
    .el-table .red {
      background: #fcb3b3;
    }
  
    .mytabs .el-tabs__content{
      height: calc(100%);
    }
  
    .mytabs .el-tabs{
      height: calc(100%);
    }
  
    .mytabs .el-table__body{
      margin-bottom: 40px;
    }
  
    .page .el-divider--horizontal{
        margin:12px 0px;
    }
  </style>


// WEBPACK FOOTER //
// src/page/beauty/beautystaffdata.vue